import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "404", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Sorry,page you are looking for was not found.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HtmlMeta = _resolveComponent("HtmlMeta")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HtmlMeta, { title: "404 - Page not found n3t Joomla! Extensions" }),
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("p", null, [
      _createTextVNode("Please continue to out "),
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createTextVNode("home page")
        ]),
        _: 1
      }),
      _createTextVNode(".")
    ])
  ], 64))
}